import React, { useEffect, useState } from 'react';

import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import Box from '@mui/material/Box';

import useTableContext from 'components/admin-portal/BaseTabsRouting/Headers/HeaderGrid/useTableContext';

import BackToListButton from './BackToListButton';
import InnerViewNavigator, {
  InnerViewNavigatorProps
} from './InnerViewNavigator';

interface ToolbarContentProps extends InnerViewNavigatorProps {
  setIsInEditMode: (param: boolean) => void;
  isInEditMode: boolean;
  toggleInnerLayout: () => void;
}

const ToolbarContent: React.FC<ToolbarContentProps> = ({
  setIsInEditMode,
  isInEditMode,
  toggleInnerLayout,
  currentView,
  setCurrentView,
  views,
  navigatorLabelGetter,
  navigatorValueGetter
}) => {
  const { contentNodeForButtons } = useTableContext();
  const [loaded, setLoaded] = useState<boolean>(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (contentNodeForButtons?.current) setLoaded(true);
  }, [contentNodeForButtons?.current]);

  return loaded ? (
    createPortal(
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        width={'100%'}
      >
        <Box display={'flex'}>
          <InnerViewNavigator
            currentView={currentView}
            setCurrentView={setCurrentView}
            views={views}
            navigatorLabelGetter={navigatorLabelGetter}
            navigatorValueGetter={navigatorValueGetter}
          />
          <Box ml={2}>
            <BackToListButton closeInnerView={toggleInnerLayout} />
          </Box>
        </Box>
        {!isInEditMode && (
          <Button
            variant="contained"
            color="dark"
            onClick={() => setIsInEditMode(true)}
          >
            {t('edit')}
          </Button>
        )}
      </Box>,
      contentNodeForButtons.current as HTMLDivElement
    )
  ) : (
    <></>
  );
};

export default ToolbarContent;
